const initialState = {
  user: null,
};

export default function userAction(state = initialState, action) {
  switch (action.type) {
    case "SIGN_IN":
      return { ...state, user: action.payload };
    case "SIGN_OUT":
      return { ...state, user: initialState };
    default:
      return state;
  }
}
